import React, { useState } from 'react';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { BulkEmailSequenceStepStatusChip } from 'features/bulk-email/sequences/components/BulkEmailSequenceStepStatusChip';
import { SEQUENCE_STATUS_IDS } from 'features/bulk-email/sequences/constants';
import strings from 'strings';
import { FPActionButton } from 'UI/components/atoms';
import { SvgArrowDown, SvgArrowUp } from 'UI/res';

import PreviewBulkMetaRows from '../../PreviewBulkMetaRows';

import { useMetaRowsSectionsStyles } from './PreviewMetaRowsSections.styled';

const {
  preview: { mailMeta: MAIL_META_STRINGS }
} = strings.bulkEmails;

export const PreviewMetaRowsSections = ({
  emailBody = null,
  firstSectionData,
  isEmailBodySectionAlwaysVisible = false,
  secondarySectionData,
  status,
  subject = ''
}) => {
  const classes = useMetaRowsSectionsStyles();
  const [shouldShowMoreData, setShouldShowMoreData] = useState(false);
  const shouldShowHtmlSection = Boolean(emailBody) && shouldShowMoreData;
  const isCanceled = status?.id === SEQUENCE_STATUS_IDS.canceled;
  const disabledClass = isCanceled ? classes.disabled : null;

  return (
    <Grid container item direction="column" className={classes.metaSection}>
      <Grid container item className={classes.subjectContainer} wrap="nowrap">
        <Typography variant="h6" className={disabledClass}>
          {subject}
        </Typography>
        <BulkEmailSequenceStepStatusChip status={status} />
      </Grid>
      <PreviewBulkMetaRows classes={{ disabled: disabledClass }} rowsToRender={firstSectionData} />
      <Grid item className={classes.buttonContainer}>
        <FPActionButton
          className={disabledClass}
          size="small"
          onClick={() => setShouldShowMoreData(!shouldShowMoreData)}
          text={strings.formatString(MAIL_META_STRINGS.showButton.text, {
            adverb: shouldShowMoreData
              ? MAIL_META_STRINGS.showButton.adverbs.less
              : MAIL_META_STRINGS.showButton.adverbs.more
          })}
          variant="text"
          icon={shouldShowMoreData ? SvgArrowUp : SvgArrowDown}
          iconPosition="right"
          iconProps={{ size: 12 }}
        />
      </Grid>
      <Collapse in={secondarySectionData && shouldShowMoreData}>
        <PreviewBulkMetaRows rowsToRender={secondarySectionData} />
      </Collapse>
      <Collapse in={shouldShowHtmlSection || isEmailBodySectionAlwaysVisible}>
        <Divider />
        <Typography
          variant="body2"
          dangerouslySetInnerHTML={{ __html: emailBody }}
          className={clsx(classes.emailBody, disabledClass)}
        />
      </Collapse>
    </Grid>
  );
};
